import { createSlice } from "@reduxjs/toolkit";

export const ProdCatUnitSlice = createSlice({
    name: "prodCatUnitSlice",
    initialState: {
        allProduct: [],
        allProductWithPagination: {
            total_page_count: 1,
            data: []
        },
        allUnit: [],
        allCat: []
    },
    reducers: {
        // get all unit reducer
        getAllProductReducer: (state, action) => {
            state.allProduct = action.payload
        },
        // get all product with pagination reducer
        getAllProductWithPaginationReducer: (state, action) => {
            state.allProductWithPagination = {
                total_page_count: action.payload.total_page_count,
                data: action.payload.data || []
            }
        },
        // get all unit reducer
        getAllUnitReducer: (state, action) => {
            state.allUnit = action.payload
        },
        // get all category reducer
        getAllCatReducer: (state, action) => {
            state.allCat = action.payload
        }
    }
})